export default __webpack_public_path__ + "static/media/cif-so.0b83e920.svg";